'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class;

var _d = require('d3');

var _d2 = _interopRequireDefault(_d);

var _ramda = require('ramda');

var _utils = require('../utils/');

var utils = _interopRequireWildcard(_utils);

var _line = require('../line');

var _line2 = _interopRequireDefault(_line);

var _accessors = require('./accessors');

var _accessors2 = _interopRequireDefault(_accessors);

var _computors = require('./computors');

var _computors2 = _interopRequireDefault(_computors);

var _eauors = require('./eauors');

var _eauors2 = _interopRequireDefault(_eauors);

var _time = require('../utils/time');

var _getAxisOptions = require('../utils/getAxisOptions');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimelineChart = (0, _accessors2.default)(_class = (0, _computors2.default)(_class = (0, _eauors2.default)(_class = function (_LineChart) {
  (0, _inherits3.default)(TimelineChart, _LineChart);

  function TimelineChart(el) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var getInitialOptions = arguments[3];
    var getAxisOptions = arguments[4];
    (0, _classCallCheck3.default)(this, TimelineChart);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TimelineChart.__proto__ || (0, _getPrototypeOf2.default)(TimelineChart)).call(this, el, options, data, getInitialOptions));

    _update(el, _this.options, data, {
      selectors: _this.constructor.selectors,
      accessors: _this.constructor.accessors,
      computors: _this.constructor.computors,
      eauors: _this.constructor.eauors
    }, _this.base, _this.axis);
    return _this;
  }

  (0, _createClass3.default)(TimelineChart, [{
    key: 'update',
    value: function update(el) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var getInitialOptions = arguments[3];
      var getAxisOptions = arguments[4];

      (0, _get3.default)(TimelineChart.prototype.__proto__ || (0, _getPrototypeOf2.default)(TimelineChart.prototype), 'update', this).call(this, el, options, data, getInitialOptions);
      _update(el, this.options, data, {
        selectors: this.constructor.selectors,
        accessors: this.constructor.accessors,
        computors: this.constructor.computors,
        eauors: this.constructor.eauors
      }, this.base, this.axis, getAxisOptions);
    }
  }]);
  return TimelineChart;
}(_line2.default)) || _class) || _class) || _class;

exports.default = TimelineChart;


function _update(el, options, data, ors, base, axis, getAxisOptions) {
  if ((0, _ramda.isNil)(axis)) {
    return;
  }
  var xAxisElement = _d2.default.select(el).select(utils.selector(ors.selectors.xAxis));
  var ticks = xAxisElement.selectAll('g');
  var ticksData = ticks.data();
  if ((0, _ramda.isEmpty)(ticksData)) {
    return;
  }
  var scale = axis.xAxis.scale();
  var range = scale.range();
  var domain = scale.domain();

  var _computeTimeSteps = (0, _time.computeTimeSteps)({ range: range, domain: domain, options: options.axis.x }),
      majorStep = _computeTimeSteps.majorStep,
      minorStep = _computeTimeSteps.minorStep;

  var minorTicks = (0, _time.computeMinorTicks)({ domain: domain, majorStep: majorStep, minorStep: minorStep, size: (0, _ramda.length)(ticksData), options: options.axis.x });
  ticks.call(ors.eauors.minorTicksUpdate, minorTicks, options.axis.x);

  if ((0, _ramda.is)(Function, getAxisOptions)) {
    var yAxisoptions = (0, _getAxisOptions.getLinearAxisOptions)(axis.yAxis, options.axis.y);
    getAxisOptions({
      computedMinY: yAxisoptions.min,
      computedMaxY: yAxisoptions.max,
      computedStepY: yAxisoptions.step,
      computedPivotY: yAxisoptions.pivot
    });
  }
};